




















































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {ELevel} from '@/services/Menus'
import {UserProfile} from '@/store/modules/views/userProfile/states'
import {IJob} from '@/store/modules/views/job/states'
import {IPaymentHistory} from '@/store/modules/views/paymentHistory/states'
import { IPayment } from '@/store/modules/views/payment/states'
@Component
export default class FormPaymentHistoryDialog extends VueExtendedBaseComponent {

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  private paymentHistoryByJobId: IPaymentHistory = null

  // @Action('paymentHistory/getPaymentHistoryByJobId')
  // private getPaymentHistoryByJobId!: (options: {}) => void

  @Action('job/putJobPayment')
  private putJobPayment!: (options: {}) => void

  @Action('paymentHistory/putPaymentHistory')
  private putPaymentHistory!: (options: {}) => void

  private paymentItemLists: IPayment[] = null

  // @Getter('payment/paymentLists')
  // private paymentItemLists!: () => void

  // @Action('payment/getPaymentList')
  // private getPaymentList!: (headerParams: {
  //   headers: {
  //     page: number
  //     limit: number
  //     sortBy: string
  //     sortDesc: boolean
  //     search: string
  //     filter: string,
  //   },
  // }) => void

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get paymentHistoryData() {
    return this.paymentHistoryByJobId
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private job!: IJob & {roles: string[], permissions: string[], accounts: string[]}

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
    centerId: this.job.centerId,
  }
  private loading = false
  private date = null
  private valid = false
  private isReadOnly = false
  private amount = 0
  private slipImg = ''
  private paymentHistory = ''
  private isEnabled = false
  private isHidden = true
  private paymentitem: Partial<IPayment> = null
  private onInputImage(file) {
    this.slipImg = file.file
  }

  private async getPaymentListFunc() {
    await HttpRequestServiceWithToken.get(
      process.env.VUE_APP_API_URL + `/v1/user/payment/center/${this.job.centerId}`,
      {}, (res: IPayment[]) => {
        this.paymentItemLists = res
      },
    )
    // await this.getPaymentList({
    //   headers: {
    //     page: this.options.page,
    //     limit: this.options.itemsPerPage,
        // sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        // sortDesc: _.get(this.options, 'sortDesc[0]', true),
    //     search: Buffer.from(this.options.search).toString('base64'),
    //     filter: Buffer.from(JSON.stringify({})).toString('base64'),
    //   },
    // })
  }

  get paymentLists() {
    return _.map(this.paymentItemLists, (item) => _.omit(item, ['_id', '__v']))
  }

  private async created() {
    this.amount = this.job.totalPrice
    await Promise.all([
      this.getPaymentHistoryByJob(),
      this.getPaymentListFunc(),
    ])

    if (!_.isEmpty(this.paymentHistoryByJobId)) {
      this.slipImg = this.paymentHistoryByJobId.slipImg || ''
      this.paymentitem = _.find(this.paymentLists, (item) => (
        (item.name === this.paymentHistoryByJobId.name) &&
        (item.accountNumber === this.paymentHistoryByJobId.accountNumber) &&
        (item.bank === this.paymentHistoryByJobId.bank)
      ))
      this.amount = this.paymentHistoryByJobId.amount || 0
    }
    if (this.job.status === 'รอตรวจสอบ') {
      this.isReadOnly = true
      this.isEnabled = true
    }
  }
  get formPaymentHistoryDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ส่งหลักฐานการโอนเงิน',
          disable: this.isEnabled,
          action: this.paymentHistoryAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async getPaymentHistoryByJob() {
    await HttpRequestServiceWithToken.getByLevel(
      process.env.VUE_APP_API_URL + '/v1', `payment-history/job/${this.job._id}`,
      {}, (res: IPaymentHistory) => {
        this.paymentHistoryByJobId = res
      },
    )
    // await this.getPaymentHistoryByJobId({id: this.job._id})
  }

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private async paymentHistoryAction() {
    const validate = this.formInstant.validate()
    if (!this.slipImg) {
      this.updateSnackbar({txt: 'กรุณาเลือกหลักฐาน.', type: 'error'})
      return false
    }
    if (validate) {
      this.loading = true
      try {
        await this.putJobPayment({
          _id: this.job._id,
          status: 'รอตรวจสอบ',
          userId: this.job.userId,
          name: this.paymentitem.name,
          bank: this.paymentitem.bank,
          accountNumber: _.includes(this.paymentitem.accountNumber, '-')
            ? _.split(this.paymentitem.accountNumber).join('')
            : this.paymentitem.accountNumber,
          // amount: this.amount,
          slipImg: this.slipImg,
        })
        this.updateSnackbar({txt: 'ส่งหลักฐานสำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        await this.callback()
        this.loading = false
      }
    } else {
      return false
    }
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private doCopyText(text) {
    (this as any).$copyText(text)
      .then((e) => {
        this.updateSnackbar({txt: 'คัดลอกข้อความสำเร็จแล้ว.', type: 'success'})
      }, (e) => {
        this.updateSnackbar({txt: 'คัดลอกข้อความไม่สำเร็จ.', type: 'error'})
      })
  }

  private remove() {
    this.paymentitem = {}
  }
}
